import * as React from 'react';

function SvgSpringPlus7(props) {
  return (
    <svg
      width={46}
      height={315}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.316 22.697V25.629L3.58 29.444l20.103 4.582L3.58 38.609l20.101 4.583L3.58 47.775l20.103 4.584L3.58 56.94l20.105 4.583L3.58 66.107l20.103 4.581L3.58 75.271l20.103 4.582-3.367.768V86.6h5V83.67l16.737-3.815L21.95 75.27l20.102-4.583-20.104-4.583 20.104-4.582L21.95 56.94l20.102-4.583-20.104-4.582 20.104-4.583L21.95 38.61l20.102-4.583-20.104-4.582 3.367-.768v-5.979h-5z"
        fill={props.springcolor}
      />
      <path
        d="M22.816 133.055v6.387l-10.052 5.996 20.103 11.992-20.103 11.992 20.103 11.993-20.103 11.992 20.103 11.992-20.103 11.992 20.103 11.993-20.103 11.992 20.103 11.992-20.103 11.993 20.103 11.992-10.051 5.996v6.387"
        stroke={props.springcolor}
        strokeWidth={5}
        strokeLinecap="square"
      />
      <path
        d="M34.349 0h-23v23h23V0zM34.349 292h-23v23h23v-23z"
        fill="#5BAD92"
      />
    </svg>
  );
}

export default SvgSpringPlus7;
